import { REWARDS } from 'constants/rewards';
import { SOURCES } from 'constants/sources';

export const initialState = {
  sources: SOURCES,
  rewards: REWARDS,
};
